import addressForm from './addressForm.json';
import createCustomer from './createCustomer.json';
import createNew from './createNew.json';
import pluginCustomerDisplay from './plugin-customerDisplay.json';
import productGroup from './productGroup.json';
import search from './search.json';
import settingsCompany from './settingsCompany.json';
import settingsCustomerDisplay from './settingsCustomerDisplay.json';
import settingsCustomerSearchResults from './settingsCustomerSearchResults.json';
import settingsLanguage from './settingsLanguage.json';
import shipping from './shipping.json';

export const enGB = {
  addressForm,
  createCustomer,
  createNew,
  'plugin-customerDisplay': pluginCustomerDisplay,
  productGroup,
  search,
  settingsCompany,
  settingsCustomerDisplay,
  settingsCustomerSearchResults,
  settingsLanguage,
  shipping,
};
